import * as React from 'react';
import { registerComponent } from '@avensia/excite/register-component';
import { useMatchSmallViewport } from '@avensia/excite/match-device-width';
import { resolveSyncIfLoadedOrThrow } from '@avensia/excite/resolve-component';

function ConditionalEntry(props: Excite.Contentful.ConditionalPlaceholder) {
  const isSmallViewport = useMatchSmallViewport();
  let candidate = null;

  if (isSmallViewport && props.displayConditions?.deviceVisibility === 'mobile') {
    candidate = props.candidate;
  } else if (!isSmallViewport && props.displayConditions?.deviceVisibility === 'desktop') {
    candidate = props.candidate;
  }

  const itemWithComponentName = (candidate ?? props.fallback) as unknown as Excite.ContentApi.IComponent;
  if (!itemWithComponentName?.componentName) {
    return null;
  }

  const Component = resolveSyncIfLoadedOrThrow(itemWithComponentName.componentName);
  return <Component {...itemWithComponentName} />;
}

export default registerComponent<Excite.Contentful.ConditionalPlaceholder>(ConditionalEntry);
